// React imports.
import React, { Component } from "react";

// App imports.
import Assessment2bMainTable from "./Assessment2bMainTable";
import Assessment2bTopParagraph from "./Assessment2bTopParagraph";
import Assessment2bQuestions from "./Assessment2bQuestions";
import Assessment2bDownloadCSV from "./Assessment2bDownloadCSV";
import TableLegendLeft from "./TableLegendLeft";

import { Assessment2bStepsEnum } from "../state";
import { Assessment2bHHDataReceivedStatusEnum } from "../state";

//ResultsOverview=1,
//ResultsDetailElectric=2,
//ResultsDetailNaturalGas=3,
//ResultsDetailFuelOil=4,
//ResultsDetailPropane=5,
//ActionPlanSummary=6,

const Assessment2b = ({ state }) => (
      <div>
          {state.CurrentAssessementStepIndex == Assessment2bStepsEnum.EnterDataNumHouseholdsDataReceived &&
          <div>
                  <p><strong><u>Step 1:</u>  # of Households for Whom Data was Collected</strong></p>
                  <p >The first step of Assessment #2B is to enter the number of households for whom  
                  electric baseload expenditure data was actually collected.</p>
                  <p>You should be collecting electric baseload expenditure data from at&nbsp;<em>least</em>:</p>
                  <ul>
                      <li>50% of your assisted households that heat with electricity.</li>
                      <li>50% of your assisted households that heat with natural gas.</li>
                      <li>20% of your assisted households that heat with fuel oil.</li>
                      <li>20% of your assisted households that heat with propane.</li>
                  </ul>
                  <p>Hitting those thresholds ensures that you are collecting data from a large  
                  enough sample to be representative of the entire population of assisted households  
                  that heat with each fuel type in your state/territory.</p>
                  <p><strong>In the table below, please enter the number of assisted households  
                  with each main heating fuel type for whom you collected electric baseload  
                  expenditure data</strong></p>
                  <p><strong>Note 1:</strong>&nbsp;Your Performance Data Form asks for the number  
                  of households for whom 12 months of consecutive billing data were collected  
                  for&nbsp;<em>both</em>&nbsp;main heating fuel&nbsp;<em>and</em>&nbsp;electricity.   
                  However, for this assessment we are only concerned with the number of households  
                  for whom electric baseload data was collected, so you will need to report this  
                  information from your own records.</p>
                  <p><strong>Note 2:</strong>&nbsp;It is possible that some of your assisted households  
                  will not have electric baseload data available because they do not use electricity  
                  or produce their own electricity. Do not include these households as households  
                  from whom electric data was received.</p>
                  <Assessment2bMainTable  fieldChangeHandler={state.assessment2bFieldChangeHandler} holder={state.Assessment2bFuelTypesStatus} step={state.Assessment2bSteps[state.CurrentAssessementStepIndex]} state={state} />
                  <TableLegendLeft />
                  <br />
              </div>
          }
          {(state.CurrentAssessementStepIndex == Assessment2bStepsEnum.ResultsOverview)
              &&
              <div>
                  <p><strong><u>Step 2:</u>   Households with Data Collected Results - Overview</strong></p>
                  Now that you have provided the necessary information, we can check to see if your
                  vendors provided data for an adequate number of households. The table
                  below shows an overview of your results. Your data will be flagged for
                  a potential data reliability issue if:
                  <br/><br/>
                  <ol>
                      <li>You received electric baseload data for less than 50% of your assisted households that heat with electricity.</li>
                      <li>You received electric baseload data for less than 50% of your assisted households that heat with natural gas.</li>
                      <li>You received electric baseload data for less than 20% of your assisted households that heat with fuel oil.</li>
                      <li>You received electric baseload data for less than 20% of your assisted households that heat with propane.</li>
                  </ol>
                  <br/><br/>
                  Since households are not required to have an electric vendor to participate in
                  LIHEAP, there will be some households from whom you have not received electric
                  data because they do not have an electric vendor. However, you should still
                  have enough households on file with electric vendors to meet these
                  thresholds for data collection. 
                  <br/><br/>
                  These results are explored more thoroughly for each fuel type in Steps 3a-3d.
                  <br/><br/>
                  <Assessment2bMainTable  fieldChangeHandler={state.assessment2bFieldChangeHandler} holder={state.Assessment2bFuelTypesStatus} step={state.Assessment2bSteps[state.CurrentAssessementStepIndex]}state={state} />
                  <TableLegendLeft />
                  <br />
              </div>
          }

          {state.CurrentAssessementStepIndex == Assessment2bStepsEnum.ResultsDetailElectric &&
              <div>
                  <p>
                      <strong><u>Step 3a:</u>  Households with Data Collected Results – Electric</strong>
                  </p>
                  <Assessment2bTopParagraph state={state}  fuelType={state.Assessment2bFuelTypesStatus.Electric} />
                  <Assessment2bMainTable  fieldChangeHandler={state.assessment2bFieldChangeHandler}
                                          holder={state.Assessment2bFuelTypesStatus}
                                          step={state.Assessment2bSteps[state.CurrentAssessementStepIndex]}
                                          state={state} />
                  <TableLegendLeft />
                  <Assessment2bQuestions state={state}  fuelType={state.Assessment2bFuelTypesStatus.Electric} />
                  <br />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment2bStepsEnum.ResultsDetailNaturalGas &&
              <div>
                  <p>
                      <strong><u>Step 3b:</u>  Households with Data Collected Results – Natural Gas</strong>
                  </p>
                  <Assessment2bTopParagraph state={state}  fuelType={state.Assessment2bFuelTypesStatus.NaturalGas} />
                  <Assessment2bMainTable  fieldChangeHandler={state.assessment2bFieldChangeHandler}
                                          holder={state.Assessment2bFuelTypesStatus}
                                          step={state.Assessment2bSteps[state.CurrentAssessementStepIndex]}
                                          state={state} />
                  <TableLegendLeft />
                  <Assessment2bQuestions state={state}  fuelType={state.Assessment2bFuelTypesStatus.NaturalGas} />
                  <br />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment2bStepsEnum.ResultsDetailFuelOil &&
              <div>
                  <p>
                      <strong><u>Step 3c:</u>  Households with Data Collected Results – Fuel Oil</strong>
                  </p>
                  <Assessment2bTopParagraph state={state}  fuelType={state.Assessment2bFuelTypesStatus.FuelOil} />
                  <Assessment2bMainTable  fieldChangeHandler={state.assessment2bFieldChangeHandler}
                                          holder={state.Assessment2bFuelTypesStatus}
                                          step={state.Assessment2bSteps[state.CurrentAssessementStepIndex]}
                                          state={state} />
                  <TableLegendLeft />
                  <Assessment2bQuestions state={state}  fuelType={state.Assessment2bFuelTypesStatus.FuelOil} />
                  <br />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment2bStepsEnum.ResultsDetailPropane &&
              <div>
                  <p>
                      <strong><u>Step 3d:</u>  Households with Data Collected Results – Propane</strong>
                  </p>
                  <Assessment2bTopParagraph state={state}  fuelType={state.Assessment2bFuelTypesStatus.Propane} />
                  <Assessment2bMainTable  fieldChangeHandler={state.assessment2bFieldChangeHandler}
                                          holder={state.Assessment2bFuelTypesStatus}
                                          step={state.Assessment2bSteps[state.CurrentAssessementStepIndex]}
                                          state={state} />
                  <TableLegendLeft />
                  <Assessment2bQuestions state={state}  fuelType={state.Assessment2bFuelTypesStatus.Propane} />
                  <br />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment2bStepsEnum.ActionPlanSummary &&
              <div>
                  <p>
                      <strong><u>Step 4:</u> Aggregated Action Plan </strong>
                  </p>
                  <p>
                      Congratulations! You have reached the end of Assessment #2b.
                      Your aggregated action plan for every issue identified in Assessment #2b is included
                      in the table below. You can now download or print the Assessment #2b action plan below.
                      Also, you can revisit this page at any time by selecting it from the list of completed
                      assessments on the Assessment Tool Selection Page.
                  </p>
                  <table id="tblDataReliabilityActionPlan">
                      <thead>
                        <tr>
                            <th>Fuel</th>
                            <th>Action Plan</th>
                        </tr>
                      </thead>
                      <tbody>
                      {state.assessment2bGetFuelTypesArray().map(fuel => {
                          return (
                              <React.Fragment key={fuel.description}>
                                  {(!state.showActionPlan(fuel))
                                  &&
                                  <tr>
                                      <td>{fuel.description}</td>
                                      <td colSpan={2}>N/A</td>
                                  </tr>}

                                  {(state.showActionPlan(fuel))
                                  &&
                                  <tr>
                                      <td>{fuel.description}</td>
                                      <td>
                                        {fuel.hHServedByVendorsDataRequestedDesc}
                                        {(fuel.hHServedByVendorsDataRequestedDesc!== null
                                          &&fuel.hHServedByVendorsDataRequestedDesc !== "")
                                          &&<React.Fragment><br/><br/></React.Fragment>
                                        }
                                        {fuel.hHServedByVendorsDataReceivedDesc}
                                        {(fuel.hHServedByVendorsDataReceivedDesc!== null
                                          &&fuel.hHServedByVendorsDataReceivedDesc !== "")
                                          &&<React.Fragment><br/><br/></React.Fragment>
                                        }
                                        {fuel.hHWithElectricDataDesc}
                                        {(fuel.hHWithElectricDataDesc!== null
                                          &&fuel.hHWithElectricDataDesc !== "")
                                          &&<React.Fragment><br/><br/></React.Fragment>
                                        }
                                        {fuel.improvePercenthouseholdDataColDesc}
                                        {(fuel.improvePercenthouseholdDataColDesc!== null
                                          &&fuel.improvePercenthouseholdDataColDesc !== "")
                                          &&<React.Fragment><br/><br/></React.Fragment>
                                        }
                                      </td>
                                  </tr>
                                  }
                              </React.Fragment>
                          )
                      })}
                      </tbody>
                  </table>
              </div>
          }
      
          <br />
          <button className="dataButton"
              onClick={() => state.assessment2bShowPreviousStep()}>
              Previous
          </button>
          {state.CurrentAssessementStepIndex < Assessment2bStepsEnum.ActionPlanSummary
          &&
              <button className="dataButton"
                  onClick={() => state.assessment2bShowNextStep()}
                  disabled={state.Assessment2bShowNextStepDisabled === true}>
                  Next
              </button>
          }
          {state.CurrentAssessementStepIndex < Assessment2bStepsEnum.ActionPlanSummary
          &&
              <button className="dataButton"
                  onClick={() => state.assessment2bShowActionPlan()}
                  disabled={state.Assessment2bShowNextStepDisabled === true}>
                  View Action Plan
              </button>
          }
          <br/>
          <button className="dataButton"
              onClick={() => state.backToStart()}>
              {state.CurrentAssessementStepIndex < Assessment2bStepsEnum.ActionPlanSummary
              &&<React.Fragment>Back to start</React.Fragment>}
              {state.CurrentAssessementStepIndex === Assessment2bStepsEnum.ActionPlanSummary
              &&<React.Fragment>Finish &amp; Save</React.Fragment>}
          </button>
          {state.CurrentAssessementStepIndex === Assessment2bStepsEnum.ActionPlanSummary
          &&
              <button className="dataButton"
                  onClick={() => window.print()}>
                  Print
              </button>
          }
          {state.CurrentAssessementStepIndex == Assessment2bStepsEnum.ActionPlanSummary
          &&
            <Assessment2bDownloadCSV fuelTypes={[state.Assessment2bFuelTypesStatus.Electric,state.Assessment2bFuelTypesStatus.NaturalGas, state.Assessment2bFuelTypesStatus.FuelOil, state.Assessment2bFuelTypesStatus.Propane]}/>
          }
          <div style={{clear:"both"}}>&nbsp;</div>
      </div>
    );

export default Assessment2b;
